"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _startsWith = _interopRequireDefault(require("lodash/startsWith"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
// ----------------------------------------------------------------------------
// ------------------------------------------------------------------- Function
// ----------------------------------------------------------------------------

/** withUrl */


var withUrl = function withUrl(checkThis, data) {
  var websiteUrl = data.websiteUrl,
      nakedWebsiteUrl = data.nakedWebsiteUrl;
  var returnString = '';

  if (!(0, _startsWith["default"])(checkThis, 'http')) {
    if ((0, _startsWith["default"])(checkThis, '/')) {
      returnString = "" + nakedWebsiteUrl + checkThis;
    } else {
      returnString = "" + websiteUrl + checkThis;
    }
  } else {
    returnString = checkThis;
  }

  return returnString;
}; // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------


var _default = withUrl;
exports["default"] = _default;
module.exports = exports.default;